import { filter, update } from 'lodash';
import React, { useState, useContext, useEffect, useRef } from 'react';
import SimpleFacetCheckbox from '../../global/components/inputs/selects/simple-facet-checkbox';
import PageContext from './../context/pageContext';
import { FiltersData } from './paginated-landing-content-app';

interface IProps {
    filtersData: FiltersData;
    updateRoleFacet: any;
    updateTopicFacet: any;
}

export default function PaginatedFilters(props: IProps) {
    const { topicFilter, setTopicFilter, roleFilter, setRoleFilter, ageFilter, setAgeFilter, activeFilter, setActiveFilter } = useContext(PageContext);
    const ExpandFiltersText = (window as any).bootstrap.ExpandFiltersText;
    const CollapseFiltersText = (window as any).bootstrap.CollapseFiltersText;
    const showRoleFilter = props.filtersData.ShowRoleFilter;
    const showTopicFilter = props.filtersData.ShowTopicFilter;
    const showAgeFilter = props.filtersData.ShowAgeRangesFilter;
    const defaultTopicSize = props.filtersData.DefaultTopicFilterSize;
    const defaultRoleSize = props.filtersData.DefaultRoleFilterSize;
    const defaultAgeSize = props.filtersData.DefaultAgeRangesFilterSize;
    const [roleFilterData, updateRoleFilterData] = useState([]);
    const [topicFilterData, updateTopicFilterData] = useState([]);
    const [ageFilterData, updateAgeFilterData] = useState([]);
    const [showAllTopics, setShowAllTopics] = useState(false);
    const [showAllRoles, setShowAllRoles] = useState(false);
    const [showAllAges, setShowAllAges] = useState(false);

    const updateTopicFilter = (filterName) => {
        let newTopicArray = [];
        let itemRemoved = false;
        topicFilter.forEach(arrayItem => {
            if (arrayItem.id == filterName.id) {
                itemRemoved = true;
            }
            else {
                newTopicArray.push(arrayItem)
            }
        })

        if (!itemRemoved) {
            newTopicArray.push(filterName)
        }
        setTopicFilter(newTopicArray);
        
    }
    

    const updateRoleFilter = (filterName) => {
        let newRoleArray = [];
        let itemRemoved = false;
        roleFilter.forEach(arrayItem => {
            if (arrayItem.id == filterName.id) {
                itemRemoved = true;
            }

            else {
                newRoleArray.push(arrayItem)
            }
        })

        if (!itemRemoved) {
            newRoleArray.push(filterName)
        }

        setRoleFilter(newRoleArray);
        
    }
    const updateAgeFilter = (filterName) => {
        let newAgeArray = [];
        let itemRemoved = false;
        ageFilter.forEach(arrayItem => {
            if (arrayItem.id == filterName.id) {
                itemRemoved = true;
            }

            else {
                newAgeArray.push(arrayItem)
            }
        })

        if (!itemRemoved) {
            newAgeArray.push(filterName)
        }

        setAgeFilter(newAgeArray);

    }

    const checkForActiveFilter = () => {
        if (roleFilter.length > 0 || topicFilter.length > 0 || ageFilter.length > 0) {
            setActiveFilter(true)
        }
        else {
            setActiveFilter(false)
        }
    }
    const updateTopicFacets = () => {
        const topicFilters = [];
        var visibleTopics = props.filtersData.TopicFilters;
        if (visibleTopics && visibleTopics.length > defaultTopicSize && !showAllTopics) {
            visibleTopics = props.filtersData.TopicFilters.slice(0, defaultTopicSize);
        }
        visibleTopics.forEach(item => {
            topicFilters.push({ id: item.Key, value: item.Value, name: item.Key })
        });
        updateTopicFilterData(topicFilters);
    }

    const updateRoleFacets = () => {
        const roleFilters = [];
        var visibleRoles = props.filtersData.RoleFilters;
        if (visibleRoles && visibleRoles.length > defaultRoleSize && !showAllRoles) {
            visibleRoles = props.filtersData.RoleFilters.slice(0, defaultRoleSize);
        }
        visibleRoles.forEach(item => {;
            roleFilters.push({ id: item.Key, value: item.Value, name: item.Key })
        });
        updateRoleFilterData(roleFilters);
    }
    const updateAgeFacets = () => {
        const ageFilters = [];
        var visibleAges = props.filtersData.AgeRangesFilters;
        if (visibleAges && visibleAges.length > defaultAgeSize && !showAllAges) {
            visibleAges = props.filtersData.AgeRangesFilters.slice(0, defaultAgeSize);
        }
        visibleAges.forEach(item => {
            ;
            ageFilters.push({ id: item.Key, value: item.Value, name: item.Key })
        });
        updateAgeFilterData(ageFilters);
    }

    useEffect(() => {
            checkForActiveFilter();
            updateRoleFacets();
        updateTopicFacets();
        updateAgeFacets();
    }, [topicFilter, roleFilter, ageFilter, showAllTopics, showAllRoles, showAllAges]);

    useEffect(() => {
        checkForActiveFilter();
        updateRoleFacets();
        updateTopicFacets();
        updateAgeFacets();
    }, [props.filtersData.TopicFilters, props.filtersData.RoleFilters, props.filtersData.AgeRangesFilters]);

    const updateTopicFilterVisibility = () => {
        setShowAllTopics(!showAllTopics);
    }

    const updateRoleFilterVisibility = () => {
        setShowAllRoles(!showAllRoles);
    }
    const updateAgeFilterVisibility = () => {
        setShowAllAges(!showAllAges);
    }

    return (

        <div className="paginated-filters-content" >

            {showTopicFilter &&
                <div className="paginated-facet-item">
                    <div className="h5-styled">{props.filtersData.TopicHeading}</div>
                    {topicFilterData.map((item, i) =>
                        <SimpleFacetCheckbox
                            term={item.name}
                            showHits={true}
                            key={i}
                            id={item.name}
                            initialCount={item.value}
                            defaultChecked={false}
                            onTermClick={() => updateTopicFilter(item)}
                        />
                    )}
                    {props.filtersData.TopicFilters.length > defaultTopicSize &&
                        <a href="javascript:void(0)" onClick={updateTopicFilterVisibility}>{showAllTopics ? CollapseFiltersText : ExpandFiltersText}</a>
                    }
                    
                </div>
            }
            {showRoleFilter &&
                <div className="paginated-facet-item">
                    <div className="h5-styled">{props.filtersData.RoleHeading}</div>
                    {roleFilterData.map((item, i) =>
                        <SimpleFacetCheckbox
                            term={item.name}
                            showHits={true}
                            key={i}
                            id={item.name}
                            initialCount={item.value}
                            defaultChecked={false}
                            onTermClick={() => updateRoleFilter(item)}
                        />
                    )}
                    {props.filtersData.RoleFilters.length > defaultRoleSize &&
                        <a href="javascript:void(0)" onClick={updateRoleFilterVisibility}>{showAllRoles ? CollapseFiltersText : ExpandFiltersText}</a>
                    }
                </div>
            }
            {showAgeFilter &&
                <div className="paginated-facet-item">
                    <div className="h5-styled">{props.filtersData.AgeRangesHeading}</div>
                    {ageFilterData.map((item, i) =>
                        <SimpleFacetCheckbox
                            term={item.name}
                            showHits={true}
                            key={i}
                            id={item.name}
                            initialCount={item.value}
                            defaultChecked={false}
                            onTermClick={() => updateAgeFilter(item)}
                        />
                    )}
                    {props.filtersData.AgeRangesFilters.length > defaultAgeSize &&
                        <a href="javascript:void(0)" onClick={updateAgeFilterVisibility}>{showAllAges ? CollapseFiltersText : ExpandFiltersText}</a>
                    }
                </div>
            }
        </div>

    );


}








